import { createReducer, on } from '@ngrx/store';
import * as fromEncodingActions from '../actions/encoding.action';
export const featureKey = 'encoding';

export interface State {
    queues: {
        data: Array<any>,
        isLoaded: Boolean
    };
    demographics: {
        data: Array<any>,
        isLoaded: Boolean
    };
    otherOptions: {
        data: Array<any>,
        isLoaded: Boolean
    };
    educationOptions: {
        data: Array<any>,
        isLoaded: Boolean
    };
    occupationOptions: {
        data: Array<any>,
        isLoaded: Boolean
    };
    documentOptions: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    queues: {
        data: [],
        isLoaded: false
    },
    demographics: {
        data: [],
        isLoaded: false
    },
    otherOptions: {
        data: [],
        isLoaded: false
    },
    educationOptions: {
        data: [],
        isLoaded: false
    },
    occupationOptions: {
        data: [],
        isLoaded: false
    },
    documentOptions: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromEncodingActions.getQueuesSuccess, (state: State, props: any) => ({
        ...state,
        queues: { data: props.data, isLoaded: true },
    })),
    on(fromEncodingActions.getDemographicsSuccess, (state: State, props: any) => ({
        ...state,
        demographics: { data: props.data, isLoaded: true },
    })),
    on(fromEncodingActions.getOtherOptionsSuccess, (state: State, props: any) => ({
        ...state,
        otherOptions: { data: props.data, isLoaded: true },
    })),
    on(fromEncodingActions.getEducationOptionsSuccess, (state: State, props: any) => ({
        ...state,
        educationOptions: { data: props.data, isLoaded: true },
    })),
    on(fromEncodingActions.getOccupationOptionsSuccess, (state: State, props: any) => ({
        ...state,
        occupationOptions: { data: props.data, isLoaded: true },
    })),
    on(fromEncodingActions.getDocumentOptionsSuccess, (state: State, props: any) => ({
        ...state,
        documentOptions: { data: props.data, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);